import {useSelector} from "react-redux";
import {StoreInterface} from "../../store/types";
import useOrderMethodsStatus from "../../hooks/availability/useOrderMethodsStatus";
import {DeliveryProvider} from "../../services/exports/Constants";
import {Trans, useTranslation} from "react-i18next";
import classnames from "classnames";
import {ReactElement} from "react";
import useAppMethods from "../../hooks/utility/useAppMethods";
import UberEatsIcon from "../../assets/logo/UberEatsIcon";

interface Props {
  className?: string;
}

export default function DeliveryCarrierInfo(props: Props): ReactElement {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Banners:DeliveryCarrierInfo' });

  const { className } = props;

  const { company } = useSelector((state: StoreInterface) => state.initialData);

  const { deliveryEnabled } = useOrderMethodsStatus();
  const { formatCurrency } = useAppMethods();

  const hasExternalDelivery = deliveryEnabled && company?.delivery_provider !== DeliveryProvider.Standalone;

  return hasExternalDelivery && (
    <div className={classnames('w-full p-small rounded-lg bg-[#FDF4EA]', className)}>
      <div className="flex">
        <p className="my-auto mr-mini">{t('title')}</p>
        <UberEatsIcon className="h-[16px] w-initial my-auto" />
      </div>
      <p className="mt-mini text-mini">
        <Trans
          t={t}
          values={{
            savings: `5-${formatCurrency(10)}`,
          }}
        >{`text`}</Trans>
      </p>
    </div>
  );
}